import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classes from "./cumulative-services.module.scss";
import ServicesList from "@/composed-views/correlated-services-list";
function CumulativeServices({
  correlatedServices,
  fromAdmin,
  offer,
  allAnnouncements,
  announcement,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <Label
        tag="h3"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.title}
      >
        Servizi erogabili rispetto ai bandi selezionati
      </Label>

      <Label tag="p" color="secondary" align="start" size="md">
        Seleziona i servizi che vuoi aggiungere per completare la tua offerta
        personalizzata. I servizi non ricoperti da ogni bando da te selezionato,
        non potranno essere inseriti nella tua soluzione
      </Label>
      <ServicesList
        services={correlatedServices}
        fromAdmin={fromAdmin}
        offer={offer}
        allAnnouncements={allAnnouncements}
        announcement={announcement}
        className={classes.list}
      />
    </Flex>
  );
}

export default CumulativeServices;
